import UserGroup from '../lib/models/UserGroup';

class UserGroupsClient {
  http = null;

  endpoint = 'v2/usergroups';

  constructor(http) {
    this.http = http;
  }

  async getUserGroups(deploymentIndexId) {
    const { data } = await this.http.get(`${this.endpoint}/deploymentindex/${deploymentIndexId}`);
    console.log(data);
    const userGroups = UserGroup.fromList(data);
    return userGroups;
  }

  async getAssetUserGroups(assetId) {
    const { data } = await this.http.get(`${this.endpoint}/assets/${assetId}/assignments`);
    console.log(data);
    const userGroups = UserGroup.fromList(data);
    return userGroups;
  }

  async saveAssetAssignments(input) {
    const url = `${this.endpoint}/assets/assign`;
    const { data } = await this.http.post(url, input);
    return data;
  }
}

export default UserGroupsClient;
